export enum PaymentMethodType {
  PayPartners = 'PayPartners',
  Tron = 'Tron',
  Ethereum = 'Ethereum',
  // TODO: Extend when BE will give us more types
}
